"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const web_ui_1 = require("@gibme/web-ui");
const types_1 = require("../../types");
const common_1 = require("../common");
const api_1 = __importDefault(require("../api"));
const verify_otp_1 = __importDefault(require("./verify_otp"));
const show_provide_mobile_modal = (record) => {
    web_ui_1.ModalHelper.once('shown', () => {
        const mobile_field = web_ui_1.ModalHelper.select('#sms_mobile');
        mobile_field.on('keyup change', event => {
            const target = $(event.target);
            (0, common_1.checkPhone)(target);
        });
        web_ui_1.ModalHelper.select('#register_mobile_button').on('click', () => __awaiter(void 0, void 0, void 0, function* () {
            if (mobile_field.hasClass('is-invalid')) {
                return;
            }
            const phone = mobile_field.val() || '';
            if (phone.length === 0) {
                return;
            }
            try {
                web_ui_1.LoadingOverlay.show();
                const status = yield api_1.default.clientRegister(Object.assign(Object.assign({}, record), { mobile: phone }));
                if (status === types_1.HTTPError.VERIFY_OTP) {
                    web_ui_1.LoadingOverlay.hide();
                    return (0, verify_otp_1.default)(Object.assign(Object.assign({}, record), { mobile: phone }), false);
                }
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'An Error Occurred!',
                    body: 'An error occurred! Please try again!'
                });
            }
            catch (_a) {
                web_ui_1.LoadingOverlay.hide();
                return web_ui_1.StatusModal.show({
                    title: 'An Error Occurred!',
                    body: 'An error occurred! Please try again!'
                });
            }
        }));
    });
    web_ui_1.ModalHelper.open({
        title: 'Mobile Number Required',
        body: $('#provide_mobile_modal').clone()
            .removeClass('d-none')
    });
};
exports.default = show_provide_mobile_modal;
